import React from 'react';
import { ConfigProvider } from 'antd';
import { antdTheme } from '../theme/antdTheme';

/** Wrap antd-heavy screens only — keeps ConfigProvider out of the homepage main chunk. */
export default function AntdProvider({ children }) {
  return <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>;
}
